export default __webpack_public_path__ + "static/media/04.d0dcc215.jpg";